module.exports = new __parcel__URL__("Design Decision.6306cc24.svg").toString();